import Home from '@app/components/teachers/Home'
import Classes from '@app/components/teachers/Classes'
import Tasks from '@app/components/teachers/Tasks'
import Leaders from '@app/containers/teachers/Leaders/LeadersContainer'
import OlympiadTask from '@app/components/teachers/Tasks/Olympiad/show'
import OlympiadTaskAnswer from '@app/components/teachers/Tasks/Answer'
import Statistics from '@app/components/teachers/Statistics'
import ClassDetails from '@app/containers/teachers/Statistics'
import Diplomas from '@app/containers/teachers/Diplomas'
import TeacherPlayerLayout from '@app/components/Template/teachers/TeacherPlayerLayout.jsx'

export default {
  Home: {
    component: Home,
    exact: true,
    path: '/teachers/home',
    alias: 'About',
  },

  Classes: {
    component: Classes,
    exact: true,
    path: '/teachers/classes'
  },

  Tasks: {
    component: Tasks,
    exact: true,
    path: '/teachers/tasks',
    alias: 'Tasks',
  },

  Leaders: {
    component: Leaders,
    exact: true,
    path: '/teachers/leaders',
    alias: 'Leaders',
  },

  OlympiadTask: {
    component: OlympiadTask,
    exact: true,
    path: '/teachers/tasks/:olympiad_id/:id',
    layout: TeacherPlayerLayout,
  },

  OlympiadTaskAnswer: {
    component: OlympiadTaskAnswer,
    exact: true,
    path: '/teachers/tasks/:olympiad_id/:id/answer'
  },

  Statistics: {
    component: Statistics,
    exact: true,
    path: '/teachers/classes/statistics',
    alias: 'Reports',
  },

  DetailedStatistics: {
    component: ClassDetails,
    exact: true,
    path: '/teachers/classes/:id/statistics'
  },

  Diplomas: {
    component: Diplomas,
    exact: true,
    path: '/teachers/classes/diplomas'
  },

  DetailedDiplomas: {
    component: Diplomas,
    exact: true,
    path: '/teachers/classes/:id/diplomas'
  }
}
